import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

const ICON_CATEGORIES = [
  {
    name: 'Questions',
    icons: [
      { path: '/icons/default-question.svg', label: 'Default Question' },
      { path: '/icons/questions/question.svg', label: 'Question' },
      { path: '/icons/questions/question2.svg', label: 'Question 2' },
      { path: '/icons/questions/questions.svg', label: 'Questions' },
      { path: '/icons/questions/light-bulb.svg', label: 'Light Bulb' },
      { path: '/icons/questions/light-bulb-speech-bubble.svg', label: 'Light Bulb Speech' },
    ],
  },
  {
    name: 'Business & Start-up',
    icons: [
      { path: '/icons/business/analytical-thinking.svg', label: 'Analytical Thinking' },
      { path: '/icons/business/business-idea.svg', label: 'Business Idea' },
      { path: '/icons/business/business-and-finance.svg', label: 'Business & Finance' },
      { path: '/icons/business/coin-stack.svg', label: 'Coin Stack' },
      { path: '/icons/business/deal.svg', label: 'Deal' },
      { path: '/icons/business/focus.svg', label: 'Focus' },
      { path: '/icons/business/innovation.svg', label: 'Innovation' },
      { path: '/icons/business/planning.svg', label: 'Planning' },
      { path: '/icons/business/target.svg', label: 'Target' },
      { path: '/icons/business/task-planning.svg', label: 'Task Planning' },
    ],
  },
  {
    name: 'Investment',
    icons: [
      { path: '/icons/investment/investment.svg', label: 'Investment' },
      { path: '/icons/investment/investment-growth.svg', label: 'Investment Growth' },
      { path: '/icons/investment/investment-chart.svg', label: 'Investment Chart' },
      { path: '/icons/investment/index-fund.svg', label: 'Index Fund' },
      { path: '/icons/investment/value.svg', label: 'Value' },
    ],
  },
];

export default function IconPicker({ open, onClose, currentIcon, onSelect }) {
  const [activeTab, setActiveTab] = useState(ICON_CATEGORIES[0].name);

  const handleSelect = (iconPath) => {
    onSelect(iconPath);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm" onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle className="text-sm">Choose Card Icon</DialogTitle>
        </DialogHeader>

        {/* Category Tabs */}
        <div className="flex gap-1 border-b border-border pb-2">
          {ICON_CATEGORIES.map((cat) => (
            <button
              key={cat.name}
              onClick={() => setActiveTab(cat.name)}
              className={`px-3 py-1.5 text-xs font-medium rounded-full transition-colors ${
                activeTab === cat.name
                  ? 'bg-odapto-orange text-white'
                  : 'text-muted-foreground hover:bg-muted'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* Icon Grid */}
        <div className="grid grid-cols-5 gap-3 py-3">
          {ICON_CATEGORIES.find((c) => c.name === activeTab)?.icons.map((icon) => (
            <button
              key={icon.path}
              onClick={() => handleSelect(icon.path)}
              className={`p-2 rounded-lg border-2 transition-all hover:shadow-md ${
                currentIcon === icon.path
                  ? 'border-odapto-orange bg-odapto-orange/10'
                  : 'border-transparent hover:border-zinc-300'
              }`}
              title={icon.label}
            >
              <img src={icon.path} alt={icon.label} className="w-10 h-10 object-contain mx-auto" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
